export const documentReady = function (fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
};

export const triggerEvent = function(el, eventName) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, true, false);
    el.dispatchEvent(event);
};

export const hasParent = function(el, possibleParentEl) {
    do {
        if (el === possibleParentEl) return true;
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return false;
};

export const closestPolyfill = function() {
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                    Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;

            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
};

// export default {
//     documentReady,
//     triggerEvent,
//     closestPolyfill,
// };
